import { ColumnDefinition } from '../types/column.types'
import { ExcelColumn } from '../../hooks/useExportToExcel'

const columnsToExcel = <T,>(
  columns: ColumnDefinition<T>[]
): ExcelColumn<T>[] =>
  columns
    .filter((col) => col.visible !== false)
    .map((col) => ({
      header: col.title,
      accessor: (row: T): string | number => {
        const raw = row[col.key]
        if (col.labelResolver) return col.labelResolver(raw)
        if (col.formatValue) return col.formatValue(raw as T[keyof T])
        if (typeof raw === 'boolean') return raw ? 'כן' : 'לא'
        return raw == null ? '' : String(raw)
      },
    }))

export default columnsToExcel
